import { createFileRoute } from "@tanstack/react-router";
import { MenuImportPage } from "../../features/ai/menu-import-page";

export const Route = createFileRoute("/restaurants/$restaurantId_/menu-import")({
	component: Page,
});

function Page() {
	const { restaurantId } = Route.useParams();
	return <MenuImportPage key={restaurantId} restaurantId={restaurantId} />;
}
